import { Box } from "@mui/material";
import HistoryDataGrid from "./telemetry-history/HistoryDataGrid";

export default function TelemetryHistory() {
  return (
    <Box>
      <HistoryDataGrid />
    </Box>
  );
}
